import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { PasswordChangePage } from '@/features/auth/PasswordChangePage';
import { meQueryOptions } from '@/features/auth/session';
import { ApiProblemError } from '@/shared/api/problem';

/**
 * Обязательная смена пароля. Экран открыт только тому, кому она назначена: остальным здесь
 * нечего делать: добровольно пароль меняют в профиле (`/profile`).
 */
export const Route = createFileRoute('/change-password')({
  beforeLoad: async ({ context }) => {
    const member = await context.queryClient.ensureQueryData(meQueryOptions).catch((error: unknown) => {
      if (error instanceof ApiProblemError && error.status === 401) {
        throw redirect({ to: '/login' });
      }
      throw error;
    });
    if (!member.mustChangePassword) {
      throw redirect({ to: '/' });
    }
    return { member };
  },
  component: ChangePasswordRoute,
});

function ChangePasswordRoute() {
  const { member } = Route.useRouteContext();
  const navigate = Route.useNavigate();
  const queryClient = useQueryClient();

  return (
    <PasswordChangePage
      member={member}
      onChanged={() => {
        // Требование сменить пароль погашено — прежний ответ «кто я» врёт.
        queryClient.removeQueries({ queryKey: meQueryOptions.queryKey });
        void navigate({ to: '/' });
      }}
      onSessionExpired={() => {
        queryClient.clear();
        void navigate({ to: '/login' });
      }}
    />
  );
}
